import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { FilterCustomerInput } from './FilterCustomerInput';
import { FilterCustomerOutput } from './FilterCustomerOutput';

export class FilterCustomerService extends HttpServiceBase {

  handle = (input?: FilterCustomerInput): Promise<Result<FilterCustomerOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<FilterCustomerOutput>>(`${this.baseUrlSislogApi}/v2/customer${parameters}`);
    return promise;
  }
}